












import Vue from 'vue'
import './VideoDisplay.scss'

export default Vue.extend({
  name: 'VideoDisplay',
  props: {
    streamToPlay: {
      type: MediaStream
    }
  },
  watch: {
    streamToPlay (newVal: MediaStream|undefined) {
      if (newVal === undefined) {
        if (this.video !== undefined) {
          this.video.pause()
        }
      } else {
        this.setupStream()
      }
    }
  },
  data: () => ({
    video: undefined as undefined|HTMLVideoElement
  }),
  created () {
    this.video = this.$refs.video as HTMLVideoElement | undefined
  },
  updated () {
    if (this.video) {
      this.video.play()
    }
  },
  mounted () {
    if (this.streamToPlay !== undefined && this.streamToPlay !== null) {
      this.setupStream()
    }
  },
  methods: {
    setupStream () {
      this.video = this.$refs.video as HTMLVideoElement | undefined
      if (this.video) {
        this.video.srcObject = this.streamToPlay
        this.video.onloadedmetadata = () => {
          if (this.video) {
            this.video.play()
          }
        }
      }
    }
  }
})
